import { DeductionReason } from '../../../generated/graphql';
import { TArgs, translate } from '../../../utils';

export const ITEMS_PER_PAGE = 10;

export const deductionReasonTooltipMap: Record<DeductionReason, TArgs> = {
    [DeductionReason.Writeoff]: translate('DeductionReason Writeoff Tooltip'),
    [DeductionReason.Waste]: translate('DeductionReason Waste Tooltip'),
};